module.exports = __webpack_public_path__ + "img/item7.e1f8c94b.png";